import { type ApiResponse } from '../types/api-response';
import { type ApiEnvelope } from '../types/api-envelope';
import { type RawPagination } from '../types/raw-pagination';
import { type NormalizedPagination } from '../types/normalized-pagination';

function normalizePagination(paginationRaw?: RawPagination): NormalizedPagination | null {
  if (!paginationRaw || typeof paginationRaw !== 'object') {
    return null;
  }

  return {
    page: paginationRaw.page,
    perPage: paginationRaw.size,
    totalPages: paginationRaw.total_pages,
    totalElements: paginationRaw.total_elements,
    isFirst: paginationRaw.first,
    isLast: paginationRaw.last,
    elements: paginationRaw.elements,
  };
}

export function unwrapApiEnvelope<T>(env: ApiEnvelope<T>): ApiResponse<T> {
  return {
    data: env.payload?.content ?? null,
    pagination: normalizePagination(env.payload?.pagination),
  };
}
